import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import '@fontsource/lora/600.css';
import '@fontsource/lora/700.css';
import App from './App';
import './styles/reset.css';
import './styles/variables.css';
import './styles/globals.css';
import './components/common/common.css';
import './components/layout/layout.css';
import './styles/pages.css';
import './styles/responsive.css';
import './styles/ui-refinements.css';
import './styles/auth.css';
import './styles/experience.css';
import './styles/accessibility.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
